import type { RowData } from '@plato/ui/components/data-table';
import { DataTable as UiDataTable } from '@plato/ui/components/data-table';
import type { ResponsiveDataTableProps } from '@plato/ui/components/responsive-data-table';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export type DataTableProps<
    TData extends RowData,
    TSummary = never,
    TSortBy = never,
    TExtraColumnMeta extends object = object,
> = Omit<
    ResponsiveDataTableProps<TData, TSummary, TSortBy, TExtraColumnMeta>,
    'sortSheetTitle' | 'sortAscendingLabel' | 'sortDescendingLabel' | 'sortSheetCloseLabel'
> & {
    responsive?: boolean;
};

export function DataTable<
    TData extends RowData,
    TSummary = never,
    TSortBy = never,
    TExtraColumnMeta extends object = object,
>({
    responsive = false,
    ...props
}: DataTableProps<TData, TSummary, TSortBy, TExtraColumnMeta>): ReactElement {
    const { t } = useTranslation('shared');

    return (
        <UiDataTable
            {...props}
            responsive={responsive}
            sortSheetTitle={t('data_table__sort_sheet_title')}
            sortAscendingLabel={t('data_table__sort_ascending')}
            sortDescendingLabel={t('data_table__sort_descending')}
            sortSheetCloseLabel={t('data_table__sort_sheet_close')}
        />
    );
}
